import request from "../utils/request";

export const get = () => request.get("/api/about");
export const create = (data) => request.post("/api/about", data);
export const update = (id) => request.put("/api/about");